module.exports = __webpack_public_path__ + "static/media/salesforce.271f382e.png";